import { InsightFilterType, InsightSummarySearchPayload } from '@buildwise/libs/insights';
import { PYTHON_SERVICE_ENDPOINTS, PythonAPI } from '@buildwise/libs/services';

class PythonProjectInsightsAPI extends PythonAPI {
  public getInsightsSearch(payload: {
    companyId: string;
    projectId: string;
    groupBy: string;
    filters?: InsightFilterType[];
    novaSearchKeyWord: string;
    includeBWInsights: boolean;
  }) {
    return this.post(PYTHON_SERVICE_ENDPOINTS.GET_INSIGHTS_SEARCH, payload);
  }

  public getInsightsSummarySearch(payload: InsightSummarySearchPayload & { projectId: string }) {
    return this.post(PYTHON_SERVICE_ENDPOINTS.GET_INSIGHTS_SUMMARY_SEARCH, payload);
  }
}

const pythonProjectInsightsAPI = new PythonProjectInsightsAPI();
export default pythonProjectInsightsAPI;
